import React, { useState } from 'react';

const FormInput = ({ id, type, label, placeholder, error, onChange, ...rest }) => {
    const [showPassword, setShowPassword] = useState(false);
    
    return (
        <div>
            <label htmlFor={id} className="block mb-2 text-sm font-medium text-gray-700 dark:text-gray-200">
                {label}
            </label>
            <div className="relative">
                <input
                    type={type === 'password' ? (showPassword ? 'text' : 'password') : type}
                    name={id}
                    id={id}
                    placeholder={placeholder}
                    onChange={onChange}
                    className="
                        bg-gray-50 
                        dark:bg-gray-700
                        border-2 
                        border-gray-300 
                        dark:border-gray-700
                        text-gray-600 
                        dark:text-gray-200
                        rounded-lg 
                        focus:ring-[#41A6D7] 
                        focus:border-[#41A6D7] 
                        block 
                        w-full 
                        p-2.5 
                        transition 
                        duration-300 
                        ease-in-out 
                        focus:outline-none 
                        shadow-sm 
                        focus:shadow-outline
                    "
                    {...rest}
                />
                {type === 'password' && (
                    <button
                        type="button"
                        className="absolute right-3 top-1/2 -translate-y-1/2"
                        onClick={() => setShowPassword(!showPassword)}
                    >
                        {showPassword ? (
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 text-gray-500">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88" />
                            </svg>
                        ) : (
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 text-gray-500">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z" />
                                <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                            </svg>
                        )}
                    </button>
                )}
            </div>
            {error && <span className="text-red-500 text-xs font-light absolute">{error}</span>}
        </div>
    );
};

export default FormInput;
